import { render, staticRenderFns } from "./item.vue?vue&type=template&id=c9fddfb4"
import script from "./item.ts?vue&type=script&lang=js&external"
export * from "./item.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c9fddfb4')) {
      api.createRecord('c9fddfb4', component.options)
    } else {
      api.reload('c9fddfb4', component.options)
    }
    module.hot.accept("./item.vue?vue&type=template&id=c9fddfb4", function () {
      api.rerender('c9fddfb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/formafarmaceutica/item.vue"
export default component.exports